import withSearch from '../../../../../../../components/Blocks/Search/hocs/withSearch';

export default withSearch;
